// FeaturesSection.js
import React from 'react';
import { Container, Box, Stack, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SecurityIcon from '@mui/icons-material/Security';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const FeatureCard = ({ icon, title, description }) => (
  <Box textAlign="center" p={3} sx={{ minWidth: { xs: '100%', sm: '33%' } }}>
    {icon}
    <Typography variant="h6" mt={2}>{title}</Typography>
    <Typography color="text.secondary">{description}</Typography>
  </Box>
);

const FeaturesSection = () => (
  <Container id="features" sx={{ py: 8 }}>
    <Typography variant="h4" textAlign="center" mb={6}>
      Características Principales
    </Typography>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={4}
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
    >
      <FeatureCard
        icon={<AccessTimeIcon fontSize="large" color="primary" />}
        title="Gestión Eficiente"
        description="Optimización de tiempos en procesos administrativos a través de la automatización y análisis de la documentación
          de un cliente para un óptimo manejo de las respuestas."
      />
      <FeatureCard
        icon={<SecurityIcon fontSize="large" color="primary" />}
        title="Seguridad"
        description="Tus datos seguros y accesibles en todo momento."
      />
      <FeatureCard
        icon={<TrendingUpIcon fontSize="large" color="primary" />}
        title="Crecimiento"
        description="Mejora la recaudación con nuestro análisis inteligente."
      />
    </Stack>
  </Container>
);

export default FeaturesSection;
